/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cli_OverlineInputs */

const en_mk_cli_overline = /** @type {(inputs: Mk_Cli_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI & AGENT-NATIVE`)
};

const id_mk_cli_overline = /** @type {(inputs: Mk_Cli_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI & AGENT-NATIVE`)
};

/**
* | output |
* | --- |
* | "CLI & AGENT-NATIVE" |
*
* @param {Mk_Cli_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cli_overline = /** @type {((inputs?: Mk_Cli_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cli_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cli_overline(inputs)
	return en_mk_cli_overline(inputs)
});